import { Input } from '@/components/atoms';
import { SurveyOverviewBuilderQuestion } from '@/pages/Surveys/SurveysOverviewBuilder/types';

import { Step } from '../../Stepper/Stepper';
import { SurveyQuestionSetStepperData, SurveyQuestionStepperData } from '../SurveyQuestionStepper';

export const SurveyQuestionTextStep = (
  stepperData: SurveyQuestionStepperData,
  setStepperData: SurveyQuestionSetStepperData,
  question: SurveyOverviewBuilderQuestion,
  index: number,
  total: number
) => {
  const step: Step = {
    value: index,
    content: (
      <div className="w-full">
        <div className="flex items-center gap-1.5 mb-5 text-body-14-medium text-custom-warm-grey-400">
          <p>
            Question {index + 1} of {total}
          </p>
          {!question.required && (
            <div className="flex items-center gap-2">
              <span className="size-1 bg-custom-warm-grey-400 inline-block rounded-full" />
              <p>Optional</p>
            </div>
          )}
        </div>
        <h4 className="text-body-24-semibold text-custom-warm-grey-700 mb-4">
          {question.question}
        </h4>
        <Input
          as="textarea"
          placeholder="Enter your answer"
          className="w-full"
          value={stepperData.answer}
          onChange={e => setStepperData(prev => ({ ...prev, answer: e.target.value }))}
        />
      </div>
    ),
  };

  return step;
};
